<template>
  <div class="card" v-if='dateAModifier'>
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-40px">
          <h1 class="title is-size-3">
            {{ $t('listeDemande.replanifier.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content is-paddingless mgr-40px mgl-40px mgt-40px">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"/>
      <div class="columns">
        <div class="column is-12">
          <b-field :label="message"
                   class="obligatoire">
            <b-datepicker show-week-number
                          v-model="dateAModifier"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          editable>
            </b-datepicker>
          </b-field>
        </div>
      </div>
      <footer class="mgt-20px mgl-0">
        <b-field class="mgl-0">
          <div class="is-pulled-left boutonAction">
            <a class="button is-cancel btn-modal-annuler mgb-40px"
               @click="$parent.close()">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction mgl-0">
            <a class="button is-addOrEdit"
               @click="update">
              {{ $t('general.button.edit') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import { updateDatePlanifieeInLignesCmd } from '@/api/ligneCommande/';
import { update } from '@/api/logistique/demandeLogistique/index';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import validation from '@/services/ligneCommande/validation/validationUpdateDatePlanifieeInLignesCmd';
import messageSuccess from '@/services/general/messageSucces';
import formatIsoDate from '@/services/general/formatIsoDate';
import translate from '@/services/ligneCommande/translate/translateUpdateDatePlanifieeInLignesCmd';
import * as demandeConf from '@/configuration/logistique/demande/demandeConf';

export default {
  props: {
    ligne: {
      required: true,
      type: Object,
    },
    type: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      dateAModifier: null,
      constantes: {
        TYPE_DEMANDE_AUTO: demandeConf.TYPE_DEMANDE_AUTO,
        TYPE_DEMANDE_LOGISTIQUE: demandeConf.TYPE_DEMANDE_LOGISTIQUE,
      },
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    async update() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messages = [];
        this.messagesChampsVide = [];
        this.error = false;
        this.champsVide = [];
        if (this.type === this.constantes.TYPE_DEMANDE_AUTO) {
          await updateDatePlanifieeInLignesCmd({
            ligneCommandeIds: [this.ligne.id],
            datePlanifieeLogistiqueAffichageDto: formatIsoDate(
              this.dateAModifier,
            ),
          });
        }
        if (this.type === this.constantes.TYPE_DEMANDE_LOGISTIQUE) {
          this.ligne.datePlanification = formatIsoDate(this.dateAModifier);
          await update(this.ligne);
        }
        this.$emit('refreshList');
        messageSuccess(this.$i18n.t('listeDemande.replanifier.messages.success.replanification'));
        this.$parent.close();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.error = true;
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    message() {
      switch (this.type) {
        case this.constantes.TYPE_DEMANDE_AUTO:
          return this.$i18n.t('listeDemande.replanifier.datePosePlanifieeAuto');
        case this.constantes.TYPE_DEMANDE_LOGISTIQUE:
          return this.$i18n.t('listeDemande.replanifier.datePosePlanifieeLogistique');
        default: return '';
      }
    },
  },
  mounted() {
    switch (this.type) {
      case this.constantes.TYPE_DEMANDE_AUTO:
        this.dateAModifier = this.ligne.datePlanifieeLogistiqueAffichage;
        break;
      case this.constantes.TYPE_DEMANDE_LOGISTIQUE:
        this.dateAModifier = new Date(this.ligne.datePlanification);
        break;
      default: break;
    }
  },
};
</script>
